import axios from "../axios";
const END_POINT = "/absence-of-users";
const registerAbsence = (payload) => axios.post(`${END_POINT}`, payload);
const searchAbsence   = (payload) => axios.post(`${END_POINT}/search`,payload);
const findAllAbsences = (unitId,date) => axios.get(`${END_POINT}/find-all-absence-for-unit/${unitId}/${date}`);
const deleteAbsences = (absenceOfUserId) => axios.delete(`${END_POINT}/${absenceOfUserId}`)


export {
    registerAbsence,
    searchAbsence,
    findAllAbsences,
    deleteAbsences
};
